export default {
  issues: {
    types: {
      ISSUE_TYPE_EPIC: 'Epic',
      ISSUE_TYPE_STORY: 'Câu chuyện',
      ISSUE_TYPE_TASK: 'Nhiệm vụ',
      ISSUE_TYPE_BUG: 'Lỗi',
      ISSUE_TYPE_SUBTASK: 'Nhiệm vụ con',
    },
    priorities: {
      PRIORITY_HIGHEST: 'Cao nhất',
      PRIORITY_HIGH: 'Cao',
      PRIORITY_MEDIUM: 'Trung bình',
      PRIORITY_LOW: 'Thấp',
      PRIORITY_LOWEST: 'Thấp nhất',
    },
    create: {
      action: 'Tạo nhiệm vụ',
      inColumn: 'Nhiệm vụ',
      title: 'Nhiệm vụ mới',
      type: 'Loại',
      name: 'Tiêu đề',
      namePlaceholder: 'Cần làm gì',
      description: 'Mô tả',
      descriptionPlaceholder: 'Chi tiết, liên kết, tiêu chí hoàn thành',
      priority: 'Độ ưu tiên',
      assignee: 'Người thực hiện',
      assigneePlaceholder: 'Chưa giao',
      noMembers: 'Dự án chưa có thành viên',
      parent: 'Nhiệm vụ cha',
      parentPlaceholder: 'Không có nhiệm vụ cha',
      noParents: 'Không có nhiệm vụ phù hợp',
      dueDate: 'Hạn',
      submit: 'Tạo',
      created: 'Đã tạo nhiệm vụ {key}',
      errors: {
        title: 'Tiêu đề tối đa {limit} ký tự',
        failed: 'Không tạo được nhiệm vụ',
      },
    },
    list: {
      columns: {
        type: 'Loại',
        key: 'Mã',
        title: 'Tiêu đề',
        status: 'Trạng thái',
        priority: 'Ưu tiên',
        assignee: 'Người làm',
        due: 'Hạn',
      },
      groupBy: {
        label: 'Nhóm theo',
        status: 'trạng thái',
        assignee: 'người làm',
        priority: 'ưu tiên',
        type: 'loại',
        none: 'không nhóm',
      },
      select: 'Chọn {key}',
      selectAll: 'Chọn tất cả trên trang',
      selected: 'Đã chọn {count} nhiệm vụ',
      clearSelection: 'Bỏ chọn',
      bulk: {
        label: 'Thao tác với mục đã chọn',
        status: 'Trạng thái',
        assignee: 'Người thực hiện',
      },
      shown: 'Hiển thị {shown} trong {total}',
      pages: 'Các trang danh sách',
      prev: 'Trang trước',
      next: 'Trang sau',
      openIssue: 'Mở nhiệm vụ {key}',
      changeStatus: 'Đổi trạng thái',
      changeAssignee: 'Đổi người làm',
      assignFailed: 'Không đổi được người làm',
      noAssignee: 'Chưa giao',
      noStatus: 'Chưa có trạng thái',
      noPriority: 'Chưa có ưu tiên',
      noType: 'Chưa có loại',
      empty: {
        title: 'Chưa có nhiệm vụ',
        description: 'Hãy tạo nhiệm vụ đầu tiên — nó sẽ xuất hiện ở đây và trên bảng.',
      },
      error: {
        title: 'Không tải được danh sách',
        description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      },
    },
  },
  issue: {
    back: 'Quay lại',
    titleLabel: 'Tên nhiệm vụ',
    saveFailed: 'Không lưu được thay đổi',
    today: 'hôm nay',
    yesterday: 'hôm qua',
    watch: 'Theo dõi',
    unwatch: 'Bỏ theo dõi',
    description: {
      empty: 'Thêm mô tả: điều kiện, liên kết, tiêu chí hoàn thành',
      edit: 'Nhấn để sửa',
    },
    history: {
      none: 'Chưa có thay đổi',
      more: 'Xem thêm',
      system: 'Hệ thống',
      created: ' đã tạo nhiệm vụ',
      changed: ' đã đổi {field}:',
      empty: '—',
      fields: {
        title: 'tên',
        description: 'mô tả',
        type: 'loại',
        priority: 'độ ưu tiên',
        assignee: 'người thực hiện',
        parent: 'nhiệm vụ cha',
        due_date: 'hạn',
        column: 'trạng thái',
        labels: 'nhãn',
        attributes: 'thuộc tính',
        deleted: 'xoá',
      },
    },
    subtasks: {
      title: 'Nhiệm vụ con',
      add: 'Thêm nhiệm vụ con',
      placeholder: 'Cần làm gì',
    },
    links: {
      empty: 'Chưa có liên kết',
      search: 'Mã hoặc tên nhiệm vụ',
      remove: 'Bỏ liên kết với {key}',
      types: {
        LINK_TYPE_BLOCKS: 'Chặn',
        LINK_TYPE_RELATES: 'Liên quan',
        LINK_TYPE_DUPLICATES: 'Trùng lặp',
        LINK_TYPE_CAUSES: 'Dẫn đến',
      },
      outbound: {
        LINK_TYPE_BLOCKS: 'chặn',
        LINK_TYPE_RELATES: 'liên quan đến',
        LINK_TYPE_DUPLICATES: 'trùng với',
        LINK_TYPE_CAUSES: 'dẫn đến',
      },
      inbound: {
        LINK_TYPE_BLOCKS: 'bị chặn bởi',
        LINK_TYPE_RELATES: 'liên quan đến',
        LINK_TYPE_DUPLICATES: 'bị trùng bởi',
        LINK_TYPE_CAUSES: 'gây ra bởi',
      },
    },
    comments: {
      placeholder: "Bình luận… ({'@'} để nhắc, DEV-NNN là liên kết nhiệm vụ)",
      send: 'Gửi',
      empty: 'Chưa có bình luận',
      more: 'Xem bình luận cũ hơn',
      edit: 'Sửa',
      remove: 'Xoá',
    },
    peek: {
      open: 'Mở trang',
      activity: 'Hoạt động',
    },
    dev: {
      title: 'GitLab',
      mr: {
        opened: 'Đang review',
        merged: 'Đã merge',
        closed: 'Đã đóng',
        draft: 'Bản nháp',
      },
      stand: {
        live: 'Môi trường đang chạy',
        removed: 'Môi trường đã gỡ',
      },
      pipeline: {
        success: 'Pipeline thành công',
        failed: 'Pipeline thất bại',
        running: 'Pipeline đang chạy',
        pending: 'Pipeline trong hàng đợi',
        created: 'Pipeline đã tạo',
        canceled: 'Pipeline đã huỷ',
        skipped: 'Pipeline bị bỏ qua',
        manual: 'Pipeline chờ chạy',
      },
    },
    pages: {
      title: 'Cơ sở tri thức',
      add: 'Liên kết trang',
      search: 'Tiêu đề hoặc nội dung trang',
      nothing: 'Không tìm thấy gì',
      remove: 'Bỏ liên kết trang «{title}»',
    },
    attachments: {
      title: 'Tệp đính kèm',
      add: 'Đính kèm tệp',
      sending: 'Đang tải lên…',
      remove: 'Xoá tệp {name}',
      count: '{count} tệp',
      kb: 'KB',
      mb: 'MB',
    },
    labels: {
      add: 'Thêm nhãn',
      remove: 'Bỏ nhãn {name}',
      search: 'Nhãn hoặc tên mới',
      create: 'Tạo «{name}»',
      none: 'Dự án chưa có nhãn nào',
    },
    activity: {
      label: 'Hoạt động của nhiệm vụ',
      comments: 'Bình luận',
      history: 'Lịch sử',
      links: 'Liên kết',
    },
    meta: {
      fold: 'Chi tiết · người thực hiện, hạn, nhãn',
      status: 'Trạng thái',
      assignee: 'Người thực hiện',
      priority: 'Độ ưu tiên',
      due: 'Hạn',
      noDue: 'Không có hạn',
      labels: 'Nhãn',
      watchers: 'Người theo dõi',
      epic: 'Epic',
      project: 'Dự án',
      created: 'Tạo {date}',
      createdBy: 'Tạo {date}, {name}',
      updated: 'Cập nhật {date}',
    },
    error: {
      title: 'Không tải được nhiệm vụ',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    },
  },
  board: {
    dropHere: 'Thả để chuyển vào đây',
    moveFailed: 'Không chuyển được nhiệm vụ',
    scrollToEnd: 'Đến cột cuối',
    scrollToStart: 'Đến cột đầu',
    nothingFound: {
      title: 'Không tìm thấy gì',
      description: 'Có nhiệm vụ, nhưng không có cái nào khớp bộ lọc. Hãy bỏ lọc hoặc đổi truy vấn.',
    },
    empty: {
      title: 'Bảng đang trống',
      description: 'Hãy tạo nhiệm vụ đầu tiên — hoặc kéo một thẻ từ cột khác vào đây.',
    },
    error: {
      title: 'Không tải được bảng',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
  },
  projects: {
    summary: {
      projects: '{count} dự án',
      issues: '{count} công việc đang mở',
      mine: 'bạn tham gia {count}',
    },
    searchPlaceholder: 'Tìm dự án…',
    filters: {
      label: 'Hiển thị dự án nào',
      all: 'Tất cả',
      mine: 'Của tôi',
      archived: 'Lưu trữ',
    },
    card: {
      inProgress: '{count} đang làm',
      open: '{count} mở',
      private: 'Dự án riêng tư',
    },
    empty: {
      title: 'Chưa có dự án',
      description: 'Tạo dự án đầu tiên — mã, tên và hồ sơ loại công việc.',
    },
    nothingFound: {
      title: 'Không tìm thấy',
      description: 'Thử từ khoá khác hoặc bỏ bộ lọc.',
    },
    error: {
      title: 'Không tải được danh sách dự án',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
    create: {
      action: 'Tạo dự án',
      title: 'Dự án mới',
      key: 'Mã',
      keyPlaceholder: 'DEV',
      name: 'Tên',
      namePlaceholder: 'Phát triển',
      description: 'Mô tả',
      descriptionPlaceholder: 'Dự án nói về gì và ai làm việc trong đó',
      profile: 'Hồ sơ dự án',
      profiles: {
        development: 'Phát triển',
        simple: 'Đơn giản',
      },
      profileHint: {
        development:
          'Epic, story, công việc, lỗi, công việc con. Bảng: backlog, cần làm, đang làm, review, kiểm thử, xong.',
        simple: 'Chỉ công việc và công việc con. Bảng: cần làm, đang làm, xong.',
      },
      private: 'Dự án riêng tư',
      privateHint: 'Dự án riêng tư chỉ hiển thị với thành viên của nó.',
      submit: 'Tạo',
      errors: {
        key: 'Chữ Latinh in hoa, từ hai đến mười ký tự',
        failed: 'Không tạo được dự án',
      },
    },
  },
  settings: {
    cancel: 'Bỏ thay đổi',
    save: 'Lưu',
    saved: 'Đã lưu cài đặt',
    saveFailed: 'Không thể lưu cài đặt',
    error: {
      title: 'Không tải được cài đặt',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
    },
    tabs: {
      columns: 'Cột',
      members: 'Thành viên',
      types: 'Loại công việc',
      general: 'Chung',
    },
    columns: {
      preset: 'Mẫu:',
      presets: {
        COLUMN_PRESET_DEVELOPMENT: 'Phát triển · 6 cột có WIP',
        COLUMN_PRESET_SIMPLE: 'Đơn giản · 3 cột không giới hạn',
      },
      presetLocked:
        'Mẫu thay toàn bộ bảng nên chỉ áp dụng cho dự án trống — dự án này đã có công việc.',
      hint: 'Mẫu tạo bộ cột ban đầu. Sau đó có thể sửa: tên, màu, nhóm trạng thái và giới hạn WIP.',
      categories: {
        STATUS_CATEGORY_OPEN: 'Đang mở',
        STATUS_CATEGORY_IN_PROGRESS: 'Đang làm',
        STATUS_CATEGORY_DONE: 'Hoàn thành',
      },
      name: 'Tên cột',
      color: 'Màu cột',
      wip: 'WIP:',
      wipLabel: 'Giới hạn WIP của cột {name}',
      remove: 'Xoá cột {name}',
      add: 'Thêm cột',
      newName: 'Cột mới',
      moveTitle: 'Chuyển công việc đi đâu',
      moveText: 'Cột đang có {count} công việc — chọn nơi chuyển đến.',
      moveTarget: 'Cột đích',
      moveSubmit: 'Xoá cột',
    },
    members: {
      remove: 'Loại {name} khỏi dự án',
      title: 'Thành viên',
      searchPlaceholder: 'Tên hoặc email nhân viên VINPROP',
      role: 'Vai trò',
      add: 'Thêm',
      nobody: 'Không tìm thấy ai',
      noDirectory: 'Không truy cập được danh bạ nhân viên: cần quyền users:read',
      roles: {
        MEMBER_ROLE_ADMIN: 'Quản trị',
        MEMBER_ROLE_MEMBER: 'Thành viên',
        MEMBER_ROLE_VIEWER: 'Người xem',
      },
      hint: 'Quản trị — cài đặt, thành viên và xoá công việc. Thành viên — làm việc với công việc và bảng. Người xem — chỉ đọc. Quyền vào tracker được cấp trong auth.',
    },
    types: {
      profiles: {
        TYPE_PROFILE_DEVELOPMENT: 'Hồ sơ: phát triển',
        TYPE_PROFILE_SIMPLE: 'Hồ sơ: đơn giản',
      },
      hint: 'Bộ loại là cố định: Epic → Story → Task và Bug → Subtask. Hồ sơ bật tắt các loại, không tạo loại riêng.',
      notes: {
        ISSUE_TYPE_EPIC: 'Cấp cao nhất: mục tiêu kéo dài vài tuần, gom story và task',
        ISSUE_TYPE_STORY: 'Giá trị cho người dùng, chia thành các task',
        ISSUE_TYPE_TASK: 'Đơn vị công việc của một người thực hiện',
        ISSUE_TYPE_BUG: 'Lỗi: có màu riêng và mặc định ưu tiên cao',
        ISSUE_TYPE_SUBTASK: 'Danh sách kiểm bên trong công việc, không lên bảng',
      },
      count: '{count} công việc',
    },
    general: {
      archive: 'Lưu trữ',
      archiveTitle: 'Lưu trữ dự án',
      restoreTitle: 'Khôi phục dự án',
      archiveNote:
        'Dự án lưu trữ rời khỏi trang chính và thanh bên. Nhiệm vụ vẫn mở được bằng liên kết.',
      archiveAction: 'Lưu trữ',
      restoreAction: 'Khôi phục',
      archiveAsk:
        'Dự án sẽ biến mất khỏi trang chính và điều hướng. Bạn có thể khôi phục ở màn hình này.',
      restoreAsk: 'Dự án sẽ xuất hiện lại ở trang chính và thanh bên.',
      archived: 'Dự án đã được lưu trữ',
      restored: 'Dự án đã được khôi phục',
      name: 'Tên dự án',
      key: 'Khoá',
      keyNote: 'Không đổi được khoá: số hiệu công việc và liên kết nhánh GitLab phụ thuộc vào nó.',
      description: 'Mô tả',
      access: 'Truy cập và quy tắc',
      private: 'Dự án riêng tư',
      privateNote: 'Chỉ thành viên dự án và quản trị viên nhìn thấy',
    },
  },
  editor: {
    mention: {
      empty: 'Không tìm thấy ai',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Đăng nhập',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Mật khẩu',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Hiện mật khẩu',
    hidePassword: 'Ẩn mật khẩu',
    submit: 'Đăng nhập',
    or: 'hoặc',
    google: 'Đăng nhập bằng Google Workspace',
    footer: "Quyền truy cập do quản trị viên VINPROP cấp · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Email hoặc mật khẩu không đúng',
      unavailable: 'Dịch vụ đăng nhập không khả dụng. Thử lại sau một phút',
    },
  },
  nav: {
    knowledgeShort: 'CSTT',
    myTasksShort: 'Của tôi',
    mobile: 'Điều hướng',
    myTasks: 'Việc của tôi',
    projects: 'Dự án',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    projectsOverline: 'Dự án',
    addProject: 'Thêm dự án',
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    projectSettings: 'Cài đặt dự án',
    collapse: 'Thu gọn menu',
    expand: 'Mở rộng menu',
    userMenu: 'Menu người dùng',
  },
  toolbar: {
    search: 'Tìm kiếm…',
    create: 'Tạo mới',
    view: {
      label: 'Chế độ xem dự án',
      board: 'Bảng',
      list: 'Danh sách',
    },
    filters: {
      assignee: 'Người thực hiện',
      type: 'Loại',
      priority: 'Ưu tiên',
      reset: 'Bỏ lọc',
      empty: 'Không có lựa chọn nào',
    },
  },
  views: {
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    myTasks: 'Việc của tôi',
    settings: 'Cài đặt dự án',
    soon: 'Màn hình sẽ có ở các task tiếp theo của epic.',
  },
  errors: {
    forbidden: {
      ask: 'Xin quyền truy cập',
      asked: 'Đã gửi yêu cầu. Quản trị viên dự án sẽ thấy nó trong thông báo.',
      askFailed: 'Không gửi được yêu cầu',
      title: 'Không có quyền vào dự án',
      description: 'Dự án ở chế độ riêng tư. Hãy xin quyền từ quản trị viên dự án.',
    },
    notFound: {
      title: 'Không tìm thấy trang',
      description: 'Hãy kiểm tra địa chỉ: mục có thể đã đổi tên, công việc đã bị chuyển hoặc xoá.',
    },
    back: 'Về việc của tôi',
  },
  palette: {
    tab: 'Tìm kiếm',
    title: 'Chuyển nhanh',
    placeholder: 'Trang cơ sở tri thức hoặc mã nhiệm vụ…',
    hint: 'Gõ hai ký tự để tìm trang. Mã dạng DEV-1421 sẽ mở nhiệm vụ.',
    nothing: 'Không tìm thấy gì',
    openIssue: 'Mở nhiệm vụ {key}',
  },
  onboarding: {
    title: 'Bắt đầu · {done}/{total}',
    steps: {
      project: 'Tạo dự án',
      issue: 'Tạo nhiệm vụ đầu tiên',
      columns: 'Thiết lập cột bảng',
      team: 'Mời đồng đội',
    },
  },
  hub: {
    activity: {
      title: 'Hoạt động gần đây',
      empty: 'Chưa có sự kiện nào. Nhiệm vụ mới, bình luận và lần triển khai sẽ hiện ở đây.',
      someone: 'Ai đó',
      kinds: {
        created: '{actor} đã tạo nhiệm vụ',
        moved: '{actor} đã chuyển sang «{subject}»',
        comment: '{actor} đã bình luận',
        merged: 'Đã hợp nhất {subject}',
        devops: '{actor}: {subject}',
        other: '{actor}: {subject}',
      },
    },
  },
  kb: {
    space: 'Không gian',
    updated: 'cập nhật {when}',
    version: 'phiên bản {version}',
    related: 'Nhiệm vụ liên quan',
    error: {
      title: 'Không mở được cơ sở tri thức',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    },
    empty: {
      title: 'Cơ sở tri thức trống',
      description: 'Chưa có không gian nào — hãy tạo cái đầu tiên, trang sẽ xuất hiện ở thanh bên.',
    },
    pick: {
      title: 'Hãy chọn một trang',
      description: 'Cây trang của không gian nằm ở thanh bên trái.',
    },
    newSpace: {
      title: 'Không gian mới',
      key: 'Mã',
      keyInvalid: 'Chữ latin in hoa và chữ số, từ hai đến mười sáu ký tự',
      name: 'Tên',
      create: 'Tạo không gian',
      failed: 'Không tạo được không gian',
    },
    blank: {
      title: 'Cơ sở tri thức trống',
      description: 'Hãy viết trang đầu tiên — nó sẽ xuất hiện trong cây bên trái.',
      create: 'Tạo trang',
    },
    edit: {
      action: 'Chỉnh sửa',
      cancel: 'Huỷ',
      crumb: '{title} — chỉnh sửa',
      titleLabel: 'Tiêu đề trang',
      titlePlaceholder: 'Tiêu đề trang',
      bodyPlaceholder: "Nội dung trang. / — khối, {'@'} — nhắc tên",
      savedAt: '✓ Đã lưu bản nháp lúc {time}',
      saveVersion: 'Lưu phiên bản',
      saveFailed: 'Không lưu được trang',
      versionSaved: 'Đã lưu phiên bản',
      restored: 'Đã khôi phục phiên bản v{number}',
      previewing: 'Đang xem phiên bản v{number}',
      closePreview: 'Đóng bản xem',
      commentLabel: 'Đã thay đổi gì',
      commentPlaceholder: 'Không bắt buộc: một dòng cho lịch sử',
    },
    versions: {
      title: 'Phiên bản',
      empty: 'Chưa có phiên bản nào. Nút «Lưu phiên bản» chụp lại trạng thái trang.',
      number: 'v{number}',
      current: 'hiện tại',
      open: 'Mở',
      restore: 'Khôi phục',
    },
    tree: {
      menu: 'Thao tác với trang',
      addChild: 'Thêm trang con',
      move: 'Di chuyển',
      delete: 'Xoá',
      newPage: 'Trang mới',
      newPageTitle: 'Trang mới',
      newParent: 'Chuyển tới',
      root: 'Về gốc không gian',
      moveTitle: 'Di chuyển «{title}»',
      deleteTitle: 'Xoá «{title}»?',
      deleteHint: 'Không thể khôi phục lại trang.',
      deleteWithChildren: 'Mọi trang con sẽ bị xoá cùng. Không thể khôi phục lại.',
      createFailed: 'Không tạo được trang',
      moveFailed: 'Không di chuyển được trang',
      deleteFailed: 'Không xoá được trang',
    },
  },
  my: {
    chips: {
      assigned: 'Giao cho tôi',
      watching: 'Đang theo dõi',
      overdue: 'Quá hạn',
    },
    due: {
      today: 'hôm nay',
      tomorrow: 'ngày mai',
    },
    error: 'Không tải được nhiệm vụ',
    errorHint: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    empty: {
      assigned: {
        title: 'Chưa có nhiệm vụ nào giao cho bạn',
        description: 'Nhiệm vụ sẽ xuất hiện khi bạn được chỉ định làm người thực hiện.',
      },
      watching: {
        title: 'Bạn chưa theo dõi nhiệm vụ nào',
        description: 'Nhấn «Theo dõi» ở một nhiệm vụ — nó sẽ xuất hiện ở đây.',
      },
      overdue: {
        title: 'Không có nhiệm vụ quá hạn',
        description: 'Mọi hạn đều còn ở phía trước.',
      },
    },
  },
  epic: {
    summary: {
      total: '{count} nhiệm vụ',
      done: '{count} xong',
      inProgress: '{count} đang làm',
      open: '{count} đang mở',
    },
    progressLabel: 'Mức hoàn thành epic',
    empty: 'Epic chưa có nhiệm vụ nào',
    pipelines: 'Pipeline của epic · theo dịch vụ',
    noPipelines: 'Chưa có lần chạy nào cho nhiệm vụ của epic',
    ops: 'Cờ và môi trường',
    activityGap: 'Chưa có dòng sự kiện của epic: tracker chỉ lưu lịch sử của từng nhiệm vụ.',
  },
  devops: {
    stand: {
      raise: 'Dựng môi trường',
      drop: 'Gỡ môi trường',
      raiseTitle: 'Dựng môi trường tính năng',
      dropTitle: 'Gỡ môi trường tính năng',
      raiseHint:
        'Nút chạy job deploy-feature của nhánh đã chọn. Giới hạn là 8 môi trường cho tất cả.',
      dropHint: 'Nút chạy job stop-feature và giải phóng chỗ trong pool.',
      nothing: 'Nhiệm vụ chưa có nhánh trong GitLab — không có gì để dựng.',
    },
    pipelines: {
      title: 'Pipeline',
      project: 'Dự án',
      status: 'Trạng thái',
      noProjects: 'Không có gì để chọn',
      searchPlaceholder: 'Tìm kiếm…',
      groupBy: 'Nhóm các lần chạy',
      byEpic: 'Theo epic',
      byService: 'Theo dịch vụ',
      window: 'Khoảng',
      windowDays: '{days} ngày',
      open: 'Mở trong GitLab',
      error: 'Không tải được các lần chạy',
      errorHint: 'Bảng tổng hợp pipeline không khả dụng. Hãy thử lại.',
      kpi: {
        success: 'Thành công · 24 giờ',
        successHint: 'trên {total}',
        failed: 'Thất bại',
        running: 'Đang chạy',
        duration: 'Thời lượng trung bình',
        delta: '{delta} giây so với hôm qua',
      },
      empty: {
        title: 'Chưa có lần chạy nào',
        description:
          'Tracker biết về các lần chạy qua webhook GitLab: chúng xuất hiện sau lần push đầu tiên vào nhánh nhiệm vụ.',
      },
    },
    envs: {
      title: 'Môi trường tính năng',
      searchPlaceholder: 'Tìm kiếm…',
      refresh: 'Làm mới',
      retry: 'Thử lại',
      error: 'Không tải được danh sách môi trường',
      errorHint: 'Nhật ký thao tác không khả dụng. Hãy thử lại.',
      actionError: 'Không thực hiện được thao tác — hãy kiểm tra pipeline của nhánh trong GitLab.',
      noIssue: 'không có nhiệm vụ',
      note: 'Nút chạy các job CI có sẵn: deploy-feature để dựng và stop-feature để gỡ. Tracker không tạo pipeline riêng mà chạy job của nhánh.',
      columns: {
        stand: 'Dịch vụ',
        issue: 'Nhiệm vụ',
        branch: 'Nhánh',
        actor: 'Người dựng',
        uptime: 'Thời gian chạy',
        actions: 'Thao tác',
      },
      state: {
        active: 'đang chạy',
        building: 'đang build',
        idle: 'bỏ không',
        buildingUptime: 'đang dựng',
      },
      uptime: {
        days: 'ngày',
        hours: 'giờ',
        minutes: 'phút',
      },
      metrics: {
        active: 'Môi trường đang chạy',
        activeHint: 'đang hoạt động',
        building: 'Đang dựng',
        idle: 'Bỏ không quá {days} ngày',
        idleHint: 'nên gỡ bỏ',
      },
      filters: {
        project: 'Dịch vụ',
        state: 'Trạng thái',
        noProjects: 'Không có gì để chọn',
      },
      actions: {
        open: 'Mở pipeline',
        redeploy: 'Dựng lại',
        drop: 'Gỡ bỏ',
      },
      empty: {
        title: 'Chưa có môi trường nào đang chạy',
        description: 'Hãy dựng từ thẻ nhiệm vụ hoặc bằng nút trên thanh công cụ.',
      },
      raise: {
        title: 'Dựng môi trường tính năng',
        hint: 'Nút chạy job deploy-feature của nhánh. Nhiệm vụ lấy từ tên nhánh — theo quy ước tên bắt đầu bằng mã nhiệm vụ.',
        service: 'Kho mã',
        branch: 'Nhánh',
        issue: 'Nhiệm vụ',
        unknownIssue: 'Không có nhiệm vụ với mã này',
      },
    },
    flags: {
      loading: 'Đang tải…',
      button: 'Cờ tính năng',
      title: 'Cờ tính năng',
      note: 'Cờ được bật tắt bằng commit vào features/dev.json hoặc features/prod.json của repo hạ tầng. Git là nguồn sự thật, tracker hiển thị trạng thái và lịch sử.',
      new: 'Cờ mới',
      newTitle: 'Cờ mới',
      newHint:
        'Cờ được tạo ở cả hai môi trường: bật ở môi trường đã chọn, tắt ở môi trường còn lại. Lint hạ tầng yêu cầu như vậy.',
      keyInvalid: 'Khoá dạng dev-1476-devops-screens: có số nhiệm vụ và viết thường',
      create: 'Tạo cờ',
      error: 'Không tải được danh sách cờ',
      errorHint: 'Không đọc được tệp cờ: hãy kiểm tra tích hợp GitLab.',
      toggleError: 'Không chuyển được cờ',
      recent: 'Thay đổi gần đây',
      turnedOn: 'đã bật trên {environment}',
      turnedOff: 'đã tắt trên {environment}',
      noIssue: 'khoá không chứa mã nhiệm vụ',
      searchPlaceholder: 'Tìm kiếm…',
      columns: {
        flag: 'Cờ',
        what: 'Nhiệm vụ',
        changed: 'Thay đổi cuối',
      },
      filters: {
        environment: 'Môi trường',
        empty: 'Không có gì để chọn',
      },
      empty: {
        title: 'Chưa có cờ nào',
        description:
          'Hãy tạo cờ đầu tiên — nó sẽ xuất hiện trong features/dev.json và features/prod.json.',
      },
    },
    repos: {
      title: 'Kho mã nguồn',
      sync: 'Đồng bộ ngay',
      ago: '{time} trước',
      events: 'push · MR · pipeline',
      noEvents: 'chưa có sự kiện',
      open: 'Mở trong GitLab',
      connect: 'Kết nối',
      recheck: 'Kết nối lại',
      disconnect: 'Ngắt kết nối',
      error: 'Không tải được danh sách kho',
      empty: 'Chưa có kho nào',
      emptyHint: 'Chưa chạy đồng bộ hoặc nhóm chưa có dự án',
      syncDone: 'Đã kiểm tra {checked}, kết nối {connected}, lỗi {failed}',
      syncFailed: 'Đồng bộ thất bại',
      connected: 'Đã kết nối {path}',
      connectFailed: 'Không kết nối được kho',
      disconnected: 'Đã ngắt {path}',
      disconnectFailed: 'Không ngắt được kho',
      note: 'Webhook cấp nhóm là tính năng trả phí của GitLab, nên hook phải đặt trên từng kho. Trình theo dõi tự đối chiếu danh sách nhóm theo lịch và đặt hook ở nơi còn thiếu: kho mới tự kết nối.',
      filters: {
        state: 'Trạng thái',
      },
      columns: {
        path: 'Kho mã nguồn',
        events: 'Sự kiện',
        lastEvent: 'Sự kiện gần nhất',
        actions: 'Thao tác',
      },
      state: {
        connected: 'đã kết nối',
        missing: 'chưa có hook',
        failed: 'hook bị tắt',
        muted: 'đã ngắt',
      },
      metrics: {
        connected: 'Đã kết nối',
        connectedHint: 'trên {total} kho',
        missing: 'Chưa có hook',
        missingHint: 'không nhận sự kiện',
        failed: 'Lỗi',
        failedHint: 'GitLab từ chối hook',
        synced: 'Đối chiếu',
        syncedHint: 'lần gần nhất',
      },
    },
    releases: {
      title: 'Bản phát hành',
      history: 'Lịch sử phát hành',
      searchPlaceholder: 'Tìm kiếm…',
      error: 'Không tải được bản phát hành',
      errorHint: 'Nhật ký thao tác không khả dụng. Hãy thử lại.',
      tagged: 'đã đặt tag',
      failed: 'lỗi',
      open: 'Mở trong GitLab',
      note: 'Tag được tạo qua GitLab API. Việc triển khai lên prod vẫn là bước thủ công của pipeline.',
      filters: {
        service: 'Dịch vụ',
        period: 'Khoảng thời gian',
        days: '{days} ngày gần đây',
        empty: 'Không có gì để chọn',
      },
      empty: {
        title: 'Chưa có bản phát hành nào',
        description:
          'Chưa có tag nào được tạo qua tracker. Tag đặt bằng tay không nằm trong nhật ký.',
      },
    },
    release: {
      button: 'Phát hành',
      title: 'Tạo bản phát hành',
      hint: 'Tag được đặt trên master. Danh sách dịch vụ chỉ là gợi ý, có thể nhập kho mã bằng tay.',
      service: 'Dịch vụ',
      tag: 'Phiên bản',
      tagInvalid: 'Phiên bản dạng v1.4.0',
      description: 'Mô tả',
      create: 'Đặt tag',
    },
  },
}
